import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47c1f05b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "responsive-layout__pair" }
const _hoisted_2 = { class: "responsive-layout__label" }
const _hoisted_3 = { class: "responsive-layout__value" }
const _hoisted_4 = {
  key: 0,
  class: "responsive-layout__pair"
}
const _hoisted_5 = { class: "responsive-layout__label" }
const _hoisted_6 = { class: "responsive-layout__value" }

import { computed, inject, useSlots, type PropType, type Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsiveLayout',
  props: {
  alignItems: {
    type: String as PropType<
      | 'align-items-center'
      | 'align-items-start'
      | 'align-items-end'
      | 'align-items-baseline'
      | 'align-items-stretch'
    >,
    default: 'align-items-center',
  },
  justify: {
    type: String as PropType<
      | 'start'
      | 'end'
      | 'center'
      | 'space-between'
      | 'space-around'
      | 'space-evenly'
    >,
    default: 'start',
  },
  marginY: {
    type: String as PropType<
      'my-0' | 'my-1' | 'my-2' | 'my-3' | 'my-4' | 'my-5'
    >,
    default: 'my-4',
  },
  width: {
    type: Number as PropType<number>,
    default: 100,
  },
  hasTwoColumns: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const slots = useSlots();

const hasIllustration = inject<Ref<boolean> | undefined>(
  'pageContentSectionHasIllustration',
  undefined,
);

const isIllustratedDetail = computed(() => Boolean(hasIllustration?.value));

const showSecondPair = computed(
  () =>
    !props.hasTwoColumns &&
    Boolean(slots['col-3'] || slots['col-4']),
);

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (isIllustratedDetail.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
      'responsive-layout',
      'responsive-layout--illustrated',
      {
        'responsive-layout--single': __props.hasTwoColumns || !showSecondPair.value,
      },
      __props.marginY,
    ]),
        style: _normalizeStyle({ width: `${__props.width}%` })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "col-1")
          ]),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "col-2")
          ])
        ]),
        (showSecondPair.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "col-3")
              ]),
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "col-4")
              ])
            ]))
          : _createCommentVNode("", true)
      ], 6))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        style: _normalizeStyle({ width: `${__props.width}%` }),
        class: _normalizeClass([__props.marginY])
      }, [
        _createVNode(_component_el_row, {
          gutter: 10,
          class: _normalizeClass(__props.alignItems),
          justify: __props.justify
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              class: "py-2 py-md-1",
              xs: 24,
              sm: 8,
              md: 6,
              lg: 3,
              xl: 2
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "col-1")
              ]),
              _: 3
            }),
            _createVNode(_component_el_col, {
              class: "py-2 py-md-1",
              xs: 24,
              sm: 16,
              md: 6,
              lg: __props.hasTwoColumns ? 21 : 9,
              xl: __props.hasTwoColumns ? 22 : 10
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "col-2")
              ]),
              _: 3
            }, 8, ["lg", "xl"]),
            (!__props.hasTwoColumns)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_col, {
                    class: "py-2 py-md-1",
                    xs: 24,
                    sm: 8,
                    md: 6,
                    lg: 3,
                    xl: 2
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "col-3")
                    ]),
                    _: 3
                  }),
                  _createVNode(_component_el_col, {
                    class: "py-2 py-md-1",
                    xs: 24,
                    sm: 16,
                    md: 6,
                    lg: 9,
                    xl: 10
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "col-4")
                    ]),
                    _: 3
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["class", "justify"])
      ], 6))
}
}

})